var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 5.28589C8.67157 5.28589 8 4.61432 8 3.78589C8 2.95746 8.67157 2.28589 9.5 2.28589C10.3284 2.28589 11 2.95746 11 3.78589C11 4.61432 10.3284 5.28589 9.5 5.28589ZM9.5 11.1179C8.67157 11.1179 8 10.4463 8 9.61792C8 8.78949 8.67157 8.11792 9.5 8.11792C10.3284 8.11792 11 8.78949 11 9.61792C11 10.4463 10.3284 11.1179 9.5 11.1179ZM8 15.4539C8 16.2823 8.67157 16.9539 9.5 16.9539C10.3284 16.9539 11 16.2823 11 15.4539C11 14.6254 10.3284 13.9539 9.5 13.9539C8.67157 13.9539 8 14.6254 8 15.4539Z",
    fill: "#5E5E66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.12fe6842.svg";
export { ForwardRef as ReactComponent };